import { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { logs } from '../utils/api';

export default function Logs() {
  const [logData, setLogData] = useState('');

  useEffect(() => {
    logs
      .all()
      .then((res) => {
        setLogData(res.data);
      })
      .catch((err) => console.log(err));
    //eslint-disable-next-line
  }, []);

  return (
    <Box
      sx={{
        whiteSpace: 'pre-line',
        p: 3,
      }}
    >
      {' '}
      <Typography sx={{ color: 'green' }}>LOGS: </Typography>
      {logData}
    </Box>
  );
}
